import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'categories-pagination-click';

/**
 * Track when a user clicks on a pagination page number or previous&#x2F;next button in a category page.
 */
export function trackCategoriesPaginationClick(
  navigationPath: string,
  pageNumber2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { navigationPath, pageNumber2 },
  });
}
